var _a;
import { getFixtureCardProps } from "../getFixtureCardProps";
import { getOutrightCardProps } from "../getOutrightCardProps";
import { getAggregateCardProps } from "../getAggregateCardProps";
import { EventsBySportIdRequest } from "sb-bff-integration";
export var EventCardPropsMapper = (_a = {},
    _a[EventsBySportIdRequest.EventTypesEnum.Fixture] = function (state, event, cms, dict) { return getFixtureCardProps(state, event, cms, dict); },
    _a[EventsBySportIdRequest.EventTypesEnum.AggregateFixture] = function (state, event, dict) { return getAggregateCardProps(state, event, dict); },
    _a[EventsBySportIdRequest.EventTypesEnum.Outright] = function (state, event, cms, dict) { return getOutrightCardProps(state, event, cms, dict); },
    _a);
//# sourceMappingURL=EventCardPropsMapper.js.map